<template>
  <div>
    <el-form ref="form" :model="formData" :rules="rules" :disabled="disabled">
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('form_label_sup_name') || '厂家名称'" prop="supName">
            <el-input
              clearable
              v-model="formData.supName"
              :placeholder="$l('form_label_pe_sup_name') || '请输入厂家名称'"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('form_label_sup_no') || '厂家编码'" prop="supNo">
            <el-input
              clearable
              v-model="formData.supNo"
              :placeholder="$l('INDEX.form_label_automatic_system_generation') || '不需要输入，由系统生成'"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('form_label_contact') || '主要联系人'" prop="contact">
            <el-input
              clearable
              v-model="formData.contact"
              :placeholder="$l('form_label_pe_contact') || '请输入主要联系人'"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('form_label_contact_mobile') || '联系人手机'" prop="contactMobile">
            <el-input
              clearable
              v-model="formData.contactMobile"
              :placeholder="$l('form_label_pe_contact_mobile') || '请输入联系人手机'"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('form_label_sup_address') || '详细地址'" prop="supAddress">
            <el-input
              clearable
              v-model="formData.supAddress"
              :placeholder="$l('form_label_pe_sup_address') || '请输入联系人手机'"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('form_label_contact_email') || '联系人email'" prop="contactEmail">
            <el-input
              clearable
              v-model="formData.contactEmail"
              :placeholder="$l('form_label_pe_contact_email') || '请输入联系人email'"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('form_label_contact_job') || '联系人职务'" prop="contactJob">
            <el-input
              clearable
              v-model="formData.contactJob"
              :placeholder="$l('form_label_pe_contact_job') || '请输入联系人email'"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
          <el-form-item :label="$l('form_label_contact_phone') || '固定电话'" prop="contactPhone">
            <el-input
              clearable
              v-model="formData.contactPhone"
              :placeholder="$l('form_label_pe_contact_phone') || '请输入固定电话'"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }">
                <el-form-item :label="$l('form_label_pe_status') || '固定电话'" prop="custStatus">
                    <br/>
                <el-radio-group v-model="formData.custStatus" :disabled="true">
                    <el-radio label="Y">有效</el-radio>
                    <el-radio label="N">无效</el-radio>
                </el-radio-group>
                </el-form-item>
                </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }" v-if="disabled">
          <el-form-item :label="$l('form_label_create_by') || '创建人'" prop="createBy">
            <el-input
              clearable
              v-model="formData.createBy"
              :placeholder="$l('INDEX.form_label_automatic_system_generation') || '不需要输入，由系统生成'"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }" v-if="disabled">
          <el-form-item :label="$l('form_label_create_date') || '创建时间'" prop="createDate">
            <el-input
              clearable
              v-model="formData.createDate"
              :placeholder="$l('INDEX.form_label_automatic_system_generation') || '不需要输入，由系统生成'"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }" v-if="disabled">
          <el-form-item :label="$l('form_label_modify_by') || '修改人'" prop="modifyBy">
            <el-input
              clearable
              v-model="formData.modifyBy"
              :placeholder="$l('INDEX.form_label_automatic_system_generation') || '不需要输入，由系统生成'"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :sm="{ span: 24 }" :md="{ span: 8 }" :lg="{ span: 6 }" v-if="disabled">
          <el-form-item :label="$l('form_label_modify_date') || '修改时间'" prop="modifyDate">
            <el-input
              clearable
              v-model="formData.modifyDate"
              :placeholder="$l('INDEX.form_label_automatic_system_generation') || '不需要输入，由系统生成'"
              :disabled="true"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button @click="save()" type="primary" size="small">保存</el-button>
      </span>
    </el-dialog> -->
    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改?' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="back()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from "@/libs/util.validate";

export default {
  props: {
    disabled: Boolean,
    supCode: String,
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: { custStatus: "Y" },
      rules: {
        supName: [
          {
            required: true,
            message: this.$l('form_label_pe_sup_name') || '请输入厂家名称',
            trigger: "blur",
          },
        ],
        supNo: [
          {
            required: false,
            message: "请输入厂家编码",
            trigger: "blur",
          },
        ],
        contact: [
          {
            required: true,
            message: this.$l('form_label_pe_contact') || "请输入主要联系人",
            trigger: "blur",
          },
        ],
        contactMobile: [
          {
            required: true,
            message: this.$l('form_label_pe_contact_mobile') || "请输入联系人手机",
            trigger: "blur",
          },
        ],
        supAddress: [
          {
            required: true,
            message: this.$l('form_label_pe_sup_address') || "请输入详细地址",
            trigger: "blur",
          },
        ],
        contactEmail: [
          {
            required: true,
            message: this.$l('form_label_pe_contact_email') || "请输入联系人Email",
            trigger: "blur",
          },
        ],
        contactJob: [
          {
            required: false,
            message: "请输入联系人职务",
            trigger: "blur",
          },
        ],
        contactPhone: [
          {
            required: false,
            message: "请输入固定电话",
            trigger: "blur",
          },
        ],
        custStatus: [
          {
            required: false,
            message: "请输入有效状态",
            trigger: "change",
          },
        ],
        createBy: [
          {
            required: false,
            message: "请输入创建人",
            trigger: "blur",
          },
        ],
        createDate: [
          {
            required: false,
            message: "请输入创建时间",
            trigger: "blur",
          },
        ],
        modifyBy: [
          {
            required: false,
            message: "请输入修改人",
            trigger: "blur",
          },
        ],
        modifyDate: [
          {
            required: false,
            message: "请输入修改时间",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (!this.params.supCode) return;

      this.$api
        .masSupplierDetailApi({
          supCode: this.params.supCode,
        })
        .then((res) => {
          this.formData = res.body;
        });
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form]);
      if (!result) return (this.backDialogVisible = false);

      let loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$api
        .masSupplierSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close();
          
          this.saveOkQuestion(res.msg);
          this.$eventBus.$emit("supplierTableReload");
          
        })
        .catch(() => {
          loadingInstance.close();
        });
    },
    cancel() {
      if (this.disabled) {
        this.close();
        return;
      }
      this.backDialogVisible = true;
    },
    close() {
      this.backDialogVisible = false;
      this.$emit("close");
    },
    //处理消息
    saveOkQuestion(msg) {
      this.$message({
          showClose: true,
          message:this.$l('INDEX.tips_save_ok') || msg,
          type: 'success'
      })
      this.openListPage()
    },
    //关闭页面
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      });
    },
    //打开列表页面
    openListPage() {
      this.$router.push({
        name: "master-supplierSet",
      });
    },
    //返回功能
    goBack() {
      if (this.disabled) {
        this.back()
        return
      }
      this.backDialogVisible = true
    },
    back() {
      this.backDialogVisible = false
      this.$router.go(-1)
    },
  },
};
</script>
